module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/oZP5Wb/images/Cover.jpg?1696332729264",
      "alt": "This image is the cover for the book Know Your Station, Know Your Station"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Know Your Station, Know Your Station\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("The wealthiest people in the solar system abandoned the Earth for a sanctuary in space, leaving the poor to die from climate change. But the 1% won’t be safe for long… because a murderer is on the loose, with the rich as their target! Soon Elise, an employee on the billionaires’ space station, is wrapped up in a deadly investigation, dragged deeper into the conspiracy as the last body she wants to go missing does. Even worse, her withdrawals from a highly addictive substance are getting worse and causing terrible hallucinations. But those drug-induced delusions are nothing compared to the gut-wrenchingly grisly discoveries at the heart of this deadly whodunnit… Bestselling novelist Sarah Gailey (Eat the Rich, Just Like Home) and rising artistic star Liana Kangas (TRVE KVLT) take a stab at the ultra-wealthy, their dreams of escaping the planet they’ve put in peril, and the consequences of that economic terror in the near future… Collects Know Your Station #1-5.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Sarah Gailey, Liana Kangas\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    BOOM! Studios\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 71
// module chunks = 0